interface CategoryBadgeProps {
  name: string;
  label: string;
  color: string;
  onRemove?: () => void;
  size?: 'sm' | 'md';
}

export function CategoryBadge({ name: _name, label, color, onRemove, size = 'sm' }: CategoryBadgeProps) {
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${sizeClasses}`}
      style={{ backgroundColor: `${color}20`, color: color, borderColor: color, borderWidth: 1 }}
    >
      {label}
      {onRemove && (
        <button
          onClick={onRemove}
          className="ml-1 hover:opacity-70"
          aria-label={`Remove ${label} tag`}
        >
          ×
        </button>
      )}
    </span>
  );
}

export default CategoryBadge;
